import config from 'config'
import React, { Fragment, useEffect, useState } from 'react'
import history from 'srcReact/helpers/history'
import { profileActions } from 'srcReact/ProfilePage'
import PageContainer from 'srcReact/PageContainer/PageContainer'
import styles from './styles.module.scss'
import AnchorLink from 'srcReact/components/common2/AnchorLink'
import Button from 'srcReact/components/common2/Button'
import Accordion from 'srcReact/components/common2/Accordion'
import Tile from 'srcReact/components/common2/Tile'
import Spinner from 'srcReact/components/common2/Spinner'
import BackNavigation from 'srcReact/components/common2/BackNavigation'
import { useDispatch, useSelector } from 'react-redux'
import { redirectToPage } from 'srcReact/helpers/history'
import { useTranslation } from 'react-i18next'
import Divider from 'srcReact/components/common2/Divider'

function MyInvites(props) {
  const dispatch = useDispatch()
  const { t } = useTranslation()

  const {
    organization: { workplace_list },
    profile: { invites },
    alert,
    common: { isNative, isMobile },
    login: { user }
  } = useSelector((state) => state)

  useEffect(() => {
    dispatch(profileActions.getInvites(5))
  }, [])

  const respondToInvite = (isChecked, invitationId) => {
    if (isChecked) {
      dispatch(profileActions.respondToInvite('refuse', invitationId))
    } else {
      dispatch(profileActions.respondToInvite('accept', invitationId))
    }
  }

  const handleClick = () => {
    redirectToPage(`/`, isNative)
  }

  const handleGoBack = () => {
    // nativeapp
    if (isNative) {
      window.location = config.webUrl + '?goBack=true'
      return
    }
    history.goBack()
  }

  const getAcronym = (str) => {
    let acronym = str
      .split(/\s/)
      .reduce((response, word) => (response += word.slice(0, 1)), '')
      .toUpperCase()
    if (acronym.length > 4) {
      return acronym.substr(0, 3) + acronym.slice(acronym.length - 1)
    }
    return acronym
  }

  return (
    <PageContainer pageTitle={t('organization.create.pageTitle')} withFooter={false} withSidebar={true}>
      <div className={styles.yourInvites}>
        <div className={styles.innerWrapper}>
          {!isMobile && <BackNavigation customHandleBack={() => handleGoBack()} />}
          {invites && !invites.loading ? (
            <Fragment>
              <Fragment>
                {isMobile && (
                  <div className={styles.backHistoryWrapper}>
                    <BackNavigation theme='white' customHandleBack={() => handleGoBack()} />
                  </div>
                )}
                <div className={styles.title}>
                  <h1
                    className={styles.titleText}
                    dangerouslySetInnerHTML={{
                      __html:
                        invites && !invites.loading && invites.list.length == 0
                          ? t('profile.invites.titleEmpty')
                          : t('profile.invites.titleWithWorkplace')
                    }}
                  />
                </div>
              </Fragment>
              {/* )} */}
              <div className={styles.body}>
                {invites && !invites.error && (
                  <div className={styles.cardWrapper}>
                    <div className={styles.cardOuter}>
                      <div className={styles.cardInner}>
                        {!invites.loading && invites.list.length == 0 ? (
                          <p className={styles.message}>
                            {workplace_list && workplace_list.items && workplace_list.items.length > 0 ? (
                              <span>{t('profile.invites.no_invitations')}</span>
                            ) : (
                              <React.Fragment>
                                <span
                                  className={styles.changeEmailText}
                                  dangerouslySetInnerHTML={{
                                    __html: t('profile.invites.no_invitations_without_workplace', {
                                      email: user && user.email ? user.email : ''
                                    })
                                  }}
                                />

                                <AnchorLink
                                  children={`(${t('global.change')})`}
                                  path={'/0/settings/account'}
                                  className={styles.changeLink}
                                  isNative={isNative}
                                />
                                <div className={styles.buttonWrapper}>
                                  <Button
                                    text={t('profile.invites.next')}
                                    style='primary'
                                    size='large'
                                    customStyle={styles.nextButton}
                                    handleClick={() => handleClick()}
                                  />
                                </div>
                              </React.Fragment>
                            )}
                          </p>
                        ) : (
                          invites.list.length > 0 && (
                            <Fragment>
                              {(workplace_list && !workplace_list.items) ||
                                (workplace_list &&
                                  workplace_list.items &&
                                  workplace_list.items.length <= 0 &&
                                  user.email && (
                                    <p className={styles.emailInfo}>
                                      {user.email} <a href='/my-account-settings/'>{`(${t('global.change')})`}</a>{' '}
                                    </p>
                                  ))}
                              {invites.list.length > 0 && (
                                <div className={styles.inviteItems}>
                                  {invites.list.map((invite, index) => {
                                    return (
                                      <React.Fragment>
                                        <div key={`invite_${invite.invitation_id}`} className={styles.inviteItem}>
                                          <div className={styles.inviteImage}>
                                            <img src={invite.organization_picture} alt={invite.workplace_name} />
                                          </div>
                                          <div className={styles.inviteContent}>
                                            <div className={styles.inviteContentCard}>
                                              <Tile size='xSmall' className={styles.customTile} color={invite.color}>
                                                <span
                                                  className={
                                                    getAcronym(invite.workplace_name).length >= 4
                                                      ? styles.smallerText
                                                      : ''
                                                  }>
                                                  {getAcronym(invite.workplace_name)}
                                                </span>
                                              </Tile>
                                            </div>
                                            {invite.hasOwnProperty('onUpdate') && invite.onUpdate && <Spinner />}
                                            <Button
                                              customStyle={styles.joinButton}
                                              type='submit'
                                              handleClick={() =>
                                                respondToInvite(invite.hasOwnProperty('accepted'), invite.invitation_id)
                                              }
                                              text={t('profile.invites.join_btn')}
                                              style='primary'
                                              size='large'
                                            />
                                          </div>
                                        </div>
                                        {index !== invites.list.length - 1 && <Divider className={styles.divider} />}
                                      </React.Fragment>
                                    )
                                  })}
                                </div>
                              )}
                            </Fragment>
                          )
                        )}
                        {!invites.loading &&
                          invites.list.length === 0 &&
                          ((workplace_list && !workplace_list.items) ||
                            (workplace_list && workplace_list.items && workplace_list.items.length <= 0 && (
                              <Accordion data={t('faqs.invites', { returnObjects: true })} />
                            )))}
                      </div>
                    </div>
                  </div>
                )}
              </div>
            </Fragment>
          ) : (
            <Spinner />
          )}
        </div>
      </div>
    </PageContainer>
  )
}

export default MyInvites
